// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"form16_tableHeader__3AWS1","rotateIcon":"form16_rotateIcon__2Kgdo","rotate":"form16_rotate__GCarb"};